<template>
  <div class="page-footer">
<!--    <nav class="nav-meta" id="hilfsmenue" aria-label="meta menu" data-text-open="Hilfs-Menü öffnen" data-text-close="Hilfs-Menü schließen" data-label-open="Hilfs-Menü öffnen" data-label-close="Hilfs-Menü schließen">-->
<!--      <div>-->
<!--        <ul>-->
<!--          <li v-for="(item, index) in footerLinks" :key="index">-->
<!--            <a :href="item.href" :title="item.title" target="_blank" rel="noopener noreferrer">{{ item.text }}</a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </nav>-->

    <footer class="footer border-0 pt-0">
      <div class="container">
        <div class="row pb-4">
          <div class="col-md-12">
            <div class="accordion">

              <div role="tablist">
                <b-card no-body>
                  <b-card-header header-tag="div" class="p-0" role="tab">
                    <b-button block v-b-toggle="'accordion-footer-12'" class="card-header__btn text-left">
                      <b-icon icon="chevron-right" class="mr-2"></b-icon>{{ appSetting.jc_client_text }}
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-footer-12" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text v-html="appSetting.jc_client_info_text"></b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div role="tablist">
                <b-card no-body>
                  <b-card-header header-tag="div" class="p-0" role="tab">
                    <b-button block v-b-toggle="'accordion-footer-8'" class="card-header__btn text-left">
                      <b-icon icon="chevron-right" class="mr-2"></b-icon>{{ translation[3627] }}
                    </b-button>
                  </b-card-header>
                  <b-collapse id="accordion-footer-8" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        <div v-if="footerImprint" v-html="footerImprint"></div>
                        <div v-else class="row">
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10540]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10541]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10542]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-2">
                            <div v-html="translation[10543]"></div>
                          </div>
                          <div class="col-12 col-md-4 col-lg-3">
                            <div v-html="translation[11839]"></div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

            </div>
          </div>
        </div>

        <div class="copyright py-3">
          <p>
            {{ translation[10544] }}
            <a
              href="https://www.jobnet.ag"
              target="_blank"
              rel="noopener"
              class="footer__link"
              title="zur Website der Jobnet.AG"
            >Jobnet.AG</a>
            &copy; {{ new Date().getFullYear() }} |
            {{ translation[16015] }} |
            <button @click="showCookieSettings" class="footer__link footer__link--button button_base">
              {{ translation[10545] }}
            </button>
          </p>
        </div>
      </div>
    </footer>

    <b-modal
      v-model="privacyModal"
      hide-header
      ok-only
      size="xl"
      centered
      scrollable
    >
      <div v-html="privacyText"></div>
    </b-modal>

<!--    <footer aria-label="Kontakt">-->
<!--      <address>-->
<!--        <span>Kreis Kleve</span> <span>Nassauerallee 15-23</span> <span>47533 Kleve</span>-->
<!--      </address>-->
<!--      <address>-->
<!--        <span>Telefon: 02821 / 85-0</span> <span>Telefax: 02821 / 85-500</span> <span>E-Mail: <a href="mailto:info@kreis-kleve.de">info@kreis-kleve.de</a></span>-->
<!--      </address>-->
<!--    </footer>-->
  </div>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';
import { getTranslationData } from '@/api/Translation';
import { mixins } from 'vue-class-component';
import PrivacyPolicyMixin from '@/mixins/PrivacyPolicyMixin';

const KREIS_KLEVE_BASE_URL = 'https://www.kreis-kleve.de';

@Component
export default class FooterComponentKle extends mixins(PrivacyPolicyMixin) {
  private arbeitgeberText = '';

  get translation() {
    return AppModule.translation;
  }

  get appSetting() {
    return AppModule.setting || {};
  }

  get footerImprint() {
    return this.appSetting.jc_impressum;
  }

  get footerLinks() {
    const base = KREIS_KLEVE_BASE_URL;
    return [
      { href: `${base}/impressum`, title: 'Impressum', text: 'Impressum' },
      { href: `${base}/kreis-kleve/kontakt`, title: 'Kontakt', text: 'Kontakt' },
      { href: `${base}/de/inhalt/elektronische-kommunikation`, title: 'elektronische Kommunikation', text: 'elektronische Kommunikation' },
      { href: `${base}/de/inhalte/datenschutzerklaerung`, title: 'Datenschutz', text: 'Datenschutz' },
      { href: `${base}/hinweisgebendenschutz`, title: 'Hinweisgebendenschutz', text: 'Hinweisgebendenschutz' },
      { href: `${base}/erklaerung-zur-barrierefreiheit`, title: 'Barrierefreiheit', text: 'Barrierefreiheit' },
      { href: `${base}/leichte-sprache`, title: 'Leichte Sprache', text: 'Leichte Sprache' },
    ];
  }

  async created() {
    try {
      const strings = await getTranslationData({
        lang: AppModule.language,
        ids: [16145],
        sid: AppModule.languageSid,
      });
      this.arbeitgeberText = strings[16145] || '';
    } catch {
      // ignore
    }
  }
}
</script>

<style lang="scss">
[theme="default"] {

  .page-footer .footer {
    font-size: 1.05rem;
    padding-top: 1.5rem;
    line-height: 1.3;
    background-color: #fff;
    font-weight: 300;

    .accordion {
      .card {
        border: none;
        border-top: 1px solid rgba(0, 0, 0, .125);
        border-radius: 0;
        background-color: transparent;
      }
      .card-body {
        a {
          color: #00A513;
        }

        h1 {
          font-size: 1.7rem;
        }

        h2 {
          font-size: 1.6rem;
        }

        h3 {
          font-size: 1.55rem;
        }
      }
      .card-header {
        background-color: transparent;
        outline: none;
        border-bottom: 0;
        svg {
          transition: transform 0.2s ease;
          color: #00A513;
        }
        button[aria-expanded="true"] {
          svg {
            transform: rotate(90deg);
          }
        }
        &__btn {
          border: none;
          background-color: transparent;
          font-weight: 600;
          padding: .5rem 0.2rem;
          border-radius: 0;
          text-align: start;
          color: #212529;
          &:focus, &:active, &:hover, &:visited {
            background-color: transparent;
            box-shadow: none !important;
            color: #212529;
          }
        }
      }
      div[role="tablist"]:last-child {
        .card-header {
          border-bottom: 1px solid rgba(0, 0, 0, .125);
        }
      }
    }

    .footer__link {
      color: #00A513;
      text-decoration: none;
      &:hover {
        color: #007a0e;
        text-decoration: none;
      }
      &--button {
        font-weight: 300;
      }
    }

    .copyright {
      font-size: 0.95rem;
    }
  }

  .button_base {
    background: none;
    border: none;
    padding: 0;
  }

  nav.nav-meta {
    background: #00A513;
    color: #fff;
    margin-bottom: .25rem
  }

  nav.nav-meta button {
    background: #00A513;
    color: #fff;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.75rem;
    padding: .875rem 1rem;
    text-align: left;
    text-decoration: underline;
    width: 100%
  }

  nav.nav-meta button:active,nav.nav-meta button:focus-visible,nav.nav-meta button:hover {
    background: #00A513;
    color: #fff;
    text-decoration: none
  }

  nav.nav-meta button[aria-expanded=true] {
    background: #00A513;
    color: #fff
  }

  @media only screen and (min-width: 760px) {
    nav.nav-meta button {
      display:none
    }
  }

  nav.nav-meta div {
    margin: 0 auto;
    max-width: 82rem;
    padding: .875rem 1rem
  }

  @media only screen and (min-width: 980px) {
    nav.nav-meta div {
      max-width:83.5rem;
      padding-right: 1.75rem;
      padding-left: 1.75rem
    }
  }

  nav.nav-meta ul li {
    display: flex;
    line-height: 1.75rem;
  }

  nav.nav-meta ul li::before {
    content: '•';
    display: inline-block;
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-right: .5rem;
    position: static
  }

  @media only screen and (max-width: 759px) {
    nav.nav-meta div[data-hidden=true] {
      display:none
    }
  }

  @media only screen and (min-width: 760px) {
    nav.nav-meta {
      margin:0;
      position: relative
    }

    nav.nav-meta::before {
      background: right top no-repeat url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 108 56'%3E%3Cpath d='m0,0c21.5698,0,32.4651,8.6279,54.8488,31.2558,16.686,16.9303,32.8837,24.7442,50.9535,24.7442h2.1976V0H0Z' style='fill:%23fff;'/%3E%3C/svg%3E");
      background-size: auto 100%;
      content: '';
      pointer-events: none;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 10rem
    }

    nav.nav-meta::after {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 5'%3E%3Crect width='10000' height='4.7361' style='fill:%23fff;'/%3E%3C/svg%3E"),url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 70'%3E%3Cpath d='m149.9047,65.1692h-26.3977c-19.8221,0-37.6429-8.7145-56.2262-27.3748C40.5972,10.9878,26.9695,0,0,0h0v4.7361c25.2541,0,37.6429,10.0406,63.9454,36.4682,19.5362,19.6076,38.4053,28.7957,59.6569,28.7957h26.3977v-4.8308h-.0953Z' style='fill:%23fff;'/%3E%3C/svg%3E");
      background-repeat: no-repeat,no-repeat;
      background-position: top right 150px,top right;
      background-size: 10000px 5px,150px 70px;
      content: '';
      height: 70px;
      pointer-events: none;
      position: absolute;
      top: 100%;
      right: 0;
      width: 100%
    }

    nav.nav-meta ul {
      display: flex;
      margin: 0;
      padding: 0;
    }

    nav.nav-meta ul li:first-child::before {
      content: none
    }

    nav.nav-meta ul li::before {
      padding: 0 .5rem
    }
  }

  .page-footer footer[aria-label="Kontakt"] {
    background: #00A513;
    box-shadow: 50vw 0 0 0 #00A513,-50vw 0 0 0 #00A513,inset 100vw 0 0 0 #00A513;
    color: #fff;
    margin: 0 auto;
    max-width: 82rem;
    padding: 1.75rem 1rem
  }

  @media only screen and (min-width: 980px) {
    .page-footer footer[aria-label="Kontakt"] {
      max-width:83.5rem;
      padding-right: 1.75rem;
      padding-left: 1.75rem
    }
  }

  .page-footer address {
    margin: 0
  }

  .page-footer address span {
    display: block;
    font-size: 17px
  }

  .page-footer footer[aria-label="Kontakt"] a {
    color: #fff;
    display: inline-block;
    margin: 0 -.125rem;
    padding: 0 .125rem;
    font-size: 17px
  }

  .page-footer footer[aria-label="Kontakt"] a:active,
  .page-footer footer[aria-label="Kontakt"] a:focus-visible,
  .page-footer footer[aria-label="Kontakt"] a:hover {
    background: #fff;
    color: #00A513
  }

  @media only screen and (max-width: 759px) {
    .page-footer address+address {
      margin-top:.875rem
    }
  }

  @media only screen and (min-width: 760px) {
    .page-footer footer[aria-label="Kontakt"] address,
    .page-footer footer[aria-label="Kontakt"] address span {
      display:flex
    }

    .page-footer footer[aria-label="Kontakt"] address span {
      display: inline-block
    }

    .page-footer footer[aria-label="Kontakt"] address span+span::before {
      content: '•';
      display: inline-block;
      padding: 0 .5rem
    }
  }

  @media only screen and (min-width: 1280px) {
    .page-footer footer[aria-label="Kontakt"] {
      display:flex
    }

    .page-footer footer[aria-label="Kontakt"] address+address::before {
      content: '•';
      display: inline-block;
      padding: 0 1rem
    }
  }
}

#accordion-footer-5 {
  p > div {
    margin-bottom: 10px;
  }
  p > b {
    display: none;
  }
  p > ul {
    list-style: none;
    padding: 0;
  }
}
</style>
